import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-inner";
import * as tags from "@repoflow/form-schema/widgets/tag";
import * as OrganizationUserQL from "queries/organization-user";
import * as OrganizationKeyQL from "queries/organization-key";
import * as KeyAccess from "components/key-access";
import { ApolloConsumer } from "@apollo/client";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = (props) => (
  <ApolloConsumer>
    {(client) => <ContentHandler {...props} client={client} />}
  </ApolloConsumer>
);

const ContentHandler = ({
  match: {
    params
  },
}) => {
  const { values, schema, base } = useSectionContext();

  return (
    <>
      <Container className="mt-4">
        <Row>
          <Col>
            <div className="float-right">
              <Link className="btn btn-primary" to={`${base}/edit`}>
                Edit
              </Link>{" "}
              <Link className="btn btn-danger" to={`${base}/remove`}>
                Remove
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Fields
              schema={schema}
              values={values}
              target={{ $ref: "/Public/Organization" }}
              config={{
                "/Public/Organization": {
                  fields: ["description", "orgId"],
                },
              }}
            />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col>
            <Link className={"btn btn-primary"} to={`${base}/user/new`}>
              <i className="fa fa-plus" /> Add User
            </Link>
          </Col>
        </Row>
        <div className="mt-2"></div>
        <Row>
          <Col>
            {/* `more` shows only when the API reports a next page. DynamoDB
                sets its cursor whenever a query fills its Limit, so a list of
                exactly 5 still offers "Show more" and the section it leads to
                then holds those same 5. */}
            <List
              onData={(results, data) => { }}
              path={"viewer.account.domains.get.organizations.get.users"}
              query={OrganizationUserQL.list}
              variables={params}
              schema={schema}
              target={{ $ref: "/Public/OrganizationUsers" }}
              empty={"No users yet."}
              more={<Link to={`${base}/user`}>Show more</Link>}
              config={{
                "/Public/OrganizationUsers": {
                  fields: [
                    "email",
                    "status",
                    "createdAt",
                  ],
                },
              }}
              content={RowUserContent}
              attributes={{ base }}

            />
          </Col>
        </Row>
        <div className="mt-4"></div>
        <Row>
          <Col>
            <Link className={"btn btn-primary"} to={`${base}/key/new`}>
              <i className="fa fa-plus" /> Add API Key
            </Link>
          </Col>
        </Row>
        <div className="mt-2"></div>
        <Row>
          <Col>
            <List
              onData={(results, data) => { }}
              path={"viewer.account.domains.get.organizations.get.keys"}
              query={OrganizationKeyQL.list}
              variables={params}
              schema={schema}
              target={{ $ref: "/Public/Key" }}
              empty={"No API keys yet."}
              more={<Link to={`${base}/key`}>Show more</Link>}
              config={{
                "/Public/Key": {
                  fields: [
                    KeyAccess.keyIdColumn,
                    "roles",
                    "createdAt",
                  ],
                },
              }}
              content={RowKeyContent}
              attributes={{ base }}
              widgets={{ tags, ...KeyAccess.widgets }}

            />
          </Col>
        </Row>
      </Container>
    </>
  );
};


const RowUserContent = ({
  item: { email },
  attributes: { base },
}) => {
  return (
    <>
      <Link className={"btn btn-primary mt-2"} to={`${base}/user/${encodeURIComponent(email)}`}>
        View
      </Link>
    </>
  )
};


const RowKeyContent = ({
  item: { keyId },
  attributes: { base },
}) => {
  return (
    <>
      <Link className={"btn btn-primary mt-2"} to={`${base}/key/${keyId}`}>
        View
      </Link>
    </>
  )
};
